export default "__VITE_ASSET__3b9a930d__"